import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { CriterionAdditionApiService } from '@app/core/api/customers/criterion-addition/criterion-addition-api.service';
import { CriterionAdditionApiRoute } from '@app/core/models/api.models';
import { RuleType } from '@app/criterion-addition/shared/models/rule.models';

@Injectable({
  providedIn: 'root',
})
export class RuleTypesApiService extends CriterionAdditionApiService {
  readonly criterionAdditionRoute = CriterionAdditionApiRoute.RuleTypes;

  getTypes(filterValues): Observable<RuleType[]> {
    if (!filterValues.platform?.length) delete filterValues.platform;
    return this.getAll<RuleType>({ filterValues });
  }
}
